module.exports = __webpack_public_path__ + "static/media/dogwood_jam.8dde42a2.png";